export abstract class NumericConstants {
    //#region These are number constants to be declared and used throught application
    
    // This constant is used to display a 3 coloumn layout for checkbox list items
    public static readonly COLUMNCOUNT: number = 3
    //#endregion

}